<template>
    <div class="mt-2">
      <div class="container">
        <span class="text-dark p-2 px-3 mb-2">
          <b>{{ curRecord.PropackName }}</b>
        </span>ประกอบด้วยชุดตรวจดังนี้
      </div>
      <table id="tableDtl" class="table table-hover display table-sm">
          <thead class="text-white" style="background:Navy">
          <tr>
              <th class="text-start">รหัส</th>
              <th class="text-start">ชื่อชุดตรวจ <span class="badge border text-white float-end me-2">ห้องตรวจ</span></th>
              <th>คำสั่ง</th>
          </tr>
          </thead>
          <tbody>
              <tr v-for="(item, index) in dataDtllists" :key="item.TestID"
              :data-id="item.PropackID" :data-testid="item.TestID" :data-propackdtlid="item.PropackDtlID"
              @click="getSelectedRow($event)">
                  <td class="text-start py-1">{{index+1}}. {{ item.TestCode }}</td>
                  <td class="text-start py-1">
                    {{ item.TestName }}
                    <span class="badge border text-success float-end me-2">{{item.RoomName}}</span>
                  </td>
                  <td class="py-1">
                      <button class="btn btn-danger btn-sm py-0" id="Delete" @click="delRecord(item)">Del</button>
                  </td>
              </tr>
          </tbody>
      </table>
      <!-- *** ยังไม่ได้จัดลำดับชุดตรวจในแพคเกจ *** -->
      <!-- *** ซ่อนปุ่มไว้ เปลี่ยนไปเรียงลำดับแบบมาตราฐาน (ห้องตรวจ->ชุดตรวจ->เทสในชุดตรวจ)*** -->
      <!-- <div class="btn-group" role="group" aria-label="Basic outlined example">
        <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งขึ้น" @click="upNdown('up');">Up</button>
        <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งลง" @click="upNdown('down');">Down</button>
      </div>
      <button type="button" class="btn btn-primary ms-2" title="จัดเก็บลำดับที่เปลี่ยนแปลง" @click="applySeqItems();">บันทึกลำดับที่จัดเรียง</button> -->
    </div>

    <!-- Modal Form : เลือกชุดตรวจ ใส่แพคเกจ -->
    <div id="addTestsuitModal" class="modal " tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header" style="background-color:Gainsboro">
                <h5 class="modal-title">เพิ่มชุดตรวจ</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-start">
                    <table id="myAddTestsuitTable" class="table table-hover table-sm display" style="width: 100%;">
                    <thead class="text-dark" style="background:LightGreen">
                    <tr>
                        <th class="text-start" style="width:50px;">รหัส</th>
                        <th class="text-start" style="width:300px;">ชื่อชุดตรวจ</th>
                        <th class="text-center" style="width:80px;">ห้องตรวจทางคลินิก</th>
                        <th style="width:40px;">คำสั่ง</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in dataTestsuitsLists" :key="item.TestID" v-bind:data-id="item.TestID">
                            <td class="text-start py-1">{{ item.TestCode }}</td>
                            <td class="text-start py-1"><b>{{ item.TestName }}</b></td>
                            <td class="text-center py-1">{{ item.room_name }}</td>
                            <td class="py-1">
                                <button type="button" class="btn btn-primary btn-sm py-0 mx-1" id="Add" @click="addDtlPropack(item)">Add</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>

                <div class="modal-footer" style="background-color:Gainsboro">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="afterCloseTestsuitsModal()">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'TestsuitDtl',
  components: {

  },
  data () {
    return {
      dataDtllists: null
    }
  },
  mounted () {
    this.getData()
    this.$nextTick(() => {
      $('#myAddTestsuitTable').DataTable()
    })
  },
  props: ['curRecord', 'dataTestsuitsLists'],
  methods: {
    // กดปุ่มปิด Dialog
    afterCloseTestsuitsModal () {
      // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
      this.refreshDtlAfterUpdate()
    },
    // กดปุ่มเพิ่มชุดตรวจ ใส่ในแพคเกจ
    addDtlPropack (item) {
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/add_dtl_propack.php',
        data: { id: item.TestID, parentid: this.curRecord.PropackID }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1000
          }).then(function (result) {
            // *** ย้ายไปรีเฟรชครั้งเดียวตอนปิด Dialog ***
            // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
            // self.refreshDtlAfterUpdate()
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    refreshDtlAfterUpdate () {
      this.$emit('onRefreshDtlAfterUpdate')
    },
    // จัดเก็บลำดับที่จัดเรียงใหม่
    applySeqItems () {
      var self = this
      var arrDtl = []
      // แปลงข้อมูลจากฟอร์ม
      var table = document.getElementById('tableDtl')
      for (var i = 1; i < table.rows.length; i++) {
        // console.log(table.rows[i].getAttribute('data-id'))
        arrDtl.push({
          PropackDtlID: table.rows[i].getAttribute('data-propackdtlid'),
          PropackID: table.rows[i].getAttribute('data-id'),
          TestID: table.rows[i].getAttribute('data-testid'),
          Seq: i,
          UserID: this.globalUserID
        })
      }
      // console.log(arrDtl)
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_propack_seqitems.php',
        data: { requestDtl: JSON.stringify(arrDtl) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกลำดับใหม่เสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            self.refreshDtlAfterUpdate()
          })
        })
        .fail(function (resp) {
          console.log(resp)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    upNdown (direction) {
      var rows = document.getElementById('tableDtl').rows
      var parent = rows[this.index].parentNode
      if (direction === 'up') {
        if (this.index > 1) {
          parent.insertBefore(rows[this.index], rows[this.index - 1])
          // when the row go up the index will be equal to index - 1
          this.index = this.index - 1
        }
      }
      if (direction === 'down') {
        if (this.index < rows.length - 1) {
          parent.insertBefore(rows[this.index + 1], rows[this.index])
          // when the row go down the index will be equal to index + 1
          this.index = this.index + 1
        }
      }
    },
    getSelectedRow (event) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      this.index = event.target.parentNode.rowIndex
      var table = document.getElementById('tableDtl')
      for (var i = 1; i < table.rows.length; i++) {
        table.rows[i].style.backgroundColor = 'white'
        table.rows[i].style.color = 'black'
      }
      table.rows[this.index].style.backgroundColor = 'MediumBlue'
      table.rows[this.index].style.color = 'white'
    },
    delRecord (item) {
      var self = this
      Swal.fire({
        title: item.TestName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/del_dtl_propack.php',
            data: { id: item.PropackDtlID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.refreshDtlAfterUpdate()
            })
          })
        }
      })
    },
    getData () {
    //   let nPropackID = 0
    //   if (this.curRecord !== null) {
    //     nPropackID = this.curRecord.PropackID
    //   }
    //   MyApiClient.get('getdata/propack_dtl_like.php?key=' + nPropackID)
      MyApiClient.get('getdata/propack_dtl_like.php?key=' + this.curRecord.PropackID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataDtllists = resp.data.response
          // setTimeout(function () { $('#myTSTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
